import type { TRuleWithTheme } from '@ackee/fela';

export const profile: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.75rem',
});

export const nameText: TRuleWithTheme = ({ theme: { colors } }) => ({
    fontWeight: '800',
    lineHeight: '1.5rem',
    fontSize: '1rem',
    display: 'block',
    color: colors.white,
});

export const positionText: TRuleWithTheme = ({ theme: { colors } }) => ({
    fontWeight: '500',
    lineHeight: '0.875rem',
    fontSize: '1.125rem',
    fontStyle: 'italic',
    opacity: '0.8',
    color: colors.white,
});
